// extracted by mini-css-extract-plugin
module.exports = {"attributeBox":"attribute_attributeBox__4p-rH","attrLink":"attribute_attrLink__3IfIO","attrImg":"attribute_attrImg__1pKJy","title":"attribute_title__1lF4U"};